<div *ngIf="isVisible" class="confirmation-modal-overlay" aria-labelledby="modal-title" role="dialog" aria-modal="true" (click)="onClose()">
  <!-- Modal container with animation -->
  <div class="confirmation-modal-container" (click)="$event.stopPropagation()">
    <div class="confirmation-modal-content">
      <!-- Icon Container -->
      <div class="confirmation-icon-container">
        <div class="confirmation-icon-circle" [class]="getIconWrapperClass()">
          <span class="material-icons confirmation-icon" [class]="getIconClass()">{{ getIconClass() }}</span>
        </div>
      </div>
      
      <!-- Header with title -->
      <div class="confirmation-header">
        <h2 class="confirmation-title" id="modal-title">
          {{ title }}
        </h2>
        <div class="confirmation-header-line"></div>
      </div>

      <!-- Message body -->
      <div class="confirmation-body">
        <p class="confirmation-message">
          {{ message }}
        </p>
      </div>

      <!-- Action buttons -->
      <div class="confirmation-actions">
        <button
          type="button"
          class="confirmation-btn confirmation-btn-cancel ripple"
          (click)="onCancel()"
        >
          <span class="material-icons">close</span>
          <span class="btn-text">{{ cancelText }}</span>
        </button>
        <button
          type="button"
          class="confirmation-btn ripple"
          [class]="getConfirmButtonClass()"
          (click)="onConfirm()"
        >
          <span class="material-icons" [class]="getConfirmIconClass()">{{ getConfirmIconClass() }}</span>
          <span class="btn-text">{{ confirmText }}</span>
        </button>
      </div>
    </div>
  </div>
</div> 